export default __webpack_public_path__ + "static/media/EpicenterWhite.8f5af059.png";